<div class="token-profile-validator"
fxLayout="row"
fxLayoutAlign="space-between start"
fxLayoutGap="10px">

    <!--        -->
    <div class="profile-info" fxFlex="50" flex layout="column">

        <div class="profile-name">
            <h3>{{profile.profileName}}</h3>
        </div>

        <!--            -->
        <!-- <div class="profile-image">
            <img [src]="validationImage"
                 alt="Token profile image">
        </div> -->

    </div>

    <!--    -->
    <div class="token-profile-form-section" fxLayoutAlign="end end"  fxFlex>


        <!--        -->
        <form class="token-profile-form"
              [formGroup]="tokenValidationForm"
              fxLayout="row wrap"
              fxLayoutGap="20px">


            <!--    Token Input     -->
            <ng-container dynamicField
                          [group]="tokenValidationForm"
                          [fields]="[fieldConfig]"></ng-container>


            <!--       Action Button      -->
<!--            <div class="validate-btn">-->
<!--                <button mat-flat-button-->
<!--                        type="button"-->
<!--                        (click)="onValidateProfile()"-->
<!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
<!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
<!--                </button>-->
<!--            </div>-->
        </form>
    </div>
</div>



